import React, { FC, useEffect, useState } from "react";
import SearchBar from "../SearchBar";
import ButtonComponent from "../ButtonComponent";
import addIcon from "../../../assets/icons/add-icon.svg";
import "./appHeader.scss";
import { Breadcrumb } from "antd";
import {
  withRouter,
  RouteComponentProps,
  generatePath,
  useHistory,
} from "react-router-dom";
import * as appRoutes from "../../../routes/routeConstants/appRoutes";
import filterIcon from "../../../assets/icons/filter-icon.svg";
import { ArrowLeftOutlined } from "@ant-design/icons";
interface CourseHeaderProps extends RouteComponentProps {
  headerText: string;
  handleSearch?: (e: any) => void;
  handleHeaderAction?: () => void;
  buttonText?: string;
  showBreadCrumb?: boolean;
  showFilter?: boolean;
  buttonIcon?: any;
  buttonContent?: string;
  showSearch?: boolean;
  showButton?: boolean;
  showBack?: boolean;
  handleFilter?: () => void;
  headerSubtitle?: string;
  searchText?: string;
}

const AppHeader: FC<CourseHeaderProps> = (props) => {
  const {
    headerText,
    handleSearch,
    handleHeaderAction,
    buttonText,
    showBreadCrumb,
    showFilter,
    buttonIcon,
    buttonContent,
    showSearch = true,
    showButton = true,
    showBack,
    handleFilter,
    headerSubtitle,
    searchText
  } = props;
  const [breadCrumbItems, setBreadCrumbItems] = useState<any>([]);
  const [urlParams, setUrlParams] = useState<any>({});
  const history = useHistory();
  useEffect(() => {
    setUrlParams(props.match.params);
    let paths = props.location.pathname.split("/");
    paths = paths.slice(1, paths.length);
    setBreadCrumbItems(
      paths.flatMap((path: string, i) =>
        path !== "boards" &&
        (paths.findIndex((value) => value == "previous_paper") > -1
          ? i == 0 || i == 3
          : i % 2 == 0)
          ? path
          : []
      )
    );
  }, []);

  return (
    <div>
      <div className="header">
        <div className="header-title">
          {showBack && (
            <span>
              <ArrowLeftOutlined onClick={() => history.goBack()} />
            </span>
          )}
          {headerText}
        </div>
        {
          headerSubtitle &&  <div className="header-subtitle">{headerSubtitle}</div>
        }
        <div className="header-options">
          {showSearch && (
            <div className="header-options__search">
              <SearchBar
                handleSearch={(e) => handleSearch && handleSearch(e)}
                value={searchText}
                visible={searchText?.length?true:false}
              />
            </div>
          )}
          {showFilter && (
            <div className="header-options__filter">
              <img src={filterIcon} alt="" onClick={handleFilter} />
            </div>
          )}
          {showButton && (
            <div className="header-options__action">
              <ButtonComponent
                buttonContent={buttonContent || `New ${buttonText}`}
                type="primary"
                onClick={handleHeaderAction}
                loading={false}
                icon={buttonIcon === undefined ? addIcon : null}
              />
            </div>
          )}
        </div>
      </div>
      {showBreadCrumb && (
        <div className="header-breadcrumb">
          <Breadcrumb separator={">"}>
            {breadCrumbItems.map((breadCrumbItem: string, i: number) => (
              <Breadcrumb.Item
                key={i}
                onClick={() => {
                  let path = "";
                  if (props.location.pathname.includes("courses")) {
                    path =
                      i === 0
                        ? appRoutes.COURSE_BOARDS
                        : i === 1
                        ? generatePath(appRoutes.COURSE_CLASS, {
                            boardName: breadCrumbItem,
                            boardId: urlParams?.boardId,
                          })
                        : i === 2
                        ? generatePath(appRoutes.COURSE_SUBJECTS, {
                            className: breadCrumbItem,
                            classId: urlParams?.classId,
                            boardName: breadCrumbItems[i - 1],
                            boardId: urlParams?.boardId,
                          })
                        : i === 3
                        ? generatePath(appRoutes.COURSE_CHAPTERS, {
                            subjectName: breadCrumbItem,
                            className: breadCrumbItems[i - 2],
                            boardName: breadCrumbItems[i - 1],
                            ...urlParams
                          })
                        : "";
                  } else if (
                    props.location.pathname.includes("previous_paper") &&
                    props.location.pathname.includes("exams")
                  ) {
                    path =
                      i == 0
                        ? appRoutes.EXAMS
                        : i == 1
                        ? generatePath(appRoutes.PREVIOUS_PAPER, {
                            examId: urlParams?.examId,
                            examName: urlParams?.examName,
                          })
                        : "";
                  } else if (props.location.pathname.includes("exams")) {
                    path =
                      i == 0
                        ? appRoutes.EXAMS
                        : i == 1
                        ? generatePath(appRoutes.EXAM_SUBJECTS, {
                            examId: urlParams?.examId,
                            examName: urlParams?.examName,
                          })
                        : i == 2
                        ? generatePath(appRoutes.EXAM_SUBJECT_CHAPTERS, {
                            examId: urlParams.examId,
                            examName: urlParams.examName,
                            subjectId: urlParams.subjectId,
                            subjectName: urlParams.subjectName,
                          })
                        : "";
                  }
                  console.log(path);
                  props.history.push(path);
                }}
              >
                {breadCrumbItem}
              </Breadcrumb.Item>
            ))}
          </Breadcrumb>
        </div>
      )}
    </div>
  );
};

export default withRouter(AppHeader);
